const Base = process.env.REACT_APP_BACKEND_URL;
const GA_id = process.env.REACT_APP_GA;

export { Base, GA_id };
